export const CORE_SERVER = 'https://easyviewimport-sid-staging.poweredbycadworx.com';
export const ART_API = 'https://art-api-dev.sca.poweredbycadworx.com';

export const IMAGE_SERVER = 'https://shop.worldemblem.com/'
export const IMAGE_ID_URL = `${CORE_SERVER}/core2/userfiles/preview?{"config":"Stahls","model":{"Id":"imageId"},"options":null}` // replace imageId when use this URL